import {isError, ThunkAnyAction} from "~src/services/apiMiddleware";
import {FORM_ERROR} from "final-form";
import {ErrResp} from "~src/shared/errors/interfaces";

export function submitErrorToFormError(res: ThunkAnyAction<unknown, ErrResp>) {
  if (isError(res)) {
    if (Array.isArray(res.error.response?.data)) {
      return {
        [FORM_ERROR]: res.error.response.data.map(({ message }: { message: string }) => message).join('\n'),
      };
    }
  }
}
